exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-group a[data-v-783130fe]{\n  margin-left: -15px;\n}\n.badge-group[data-v-783130fe]{\n  flex-wrap: wrap;\n  padding-left: 30px;\n  display: flex;\n  height: 100%;\n  min-height: 85px;\n}\n\n", ""]);

// exports
